import React from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
import { SvgView as SvgViewCompiled } from './svgImage-compiled';
import { SvgView as SvgViewEmotion } from './svgImage-emotion';
import { SvgView as SvgViewV2 } from './svgViewV2';
export var SvgView = function SvgView(props) {
  return fg('platform_media_card_image_render') ? /*#__PURE__*/React.createElement(SvgViewV2, props) : fg('platform_media_compiled') ? /*#__PURE__*/React.createElement(SvgViewCompiled, props) : /*#__PURE__*/React.createElement(SvgViewEmotion, props);
};